module.exports = __webpack_public_path__ + "41791cbf8857c0538675dbac08f370e3.jpg";